const state = {
  isClick: false
}

const getters = {}

const mutations = {
  SET_ISCLICK: (state, isClick) => {
    state.isClick = isClick
  },
}

const actions = {
  setIsClick(context,isClick ) {
    context.commit('SET_ISCLICK',isClick )
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
